export default __webpack_public_path__ + "blitz-icon-b7067ff16bef27b00df70eab2843581c.svg";